import type * as GraphQLTypes from '../../../graphql/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DeletePackageTicketMutationVariables = GraphQLTypes.Exact<{
  packageId: GraphQLTypes.Scalars['String'];
  ticketId: GraphQLTypes.Scalars['String'];
}>;


export type DeletePackageTicketMutationResult = (
  { __typename?: 'Mutation' }
  & Pick<GraphQLTypes.Mutation, 'deletePackageTicket'>
);


export const DeletePackageTicketDocument = /*#__PURE__*/ gql`
    mutation deletePackageTicket($packageId: String!, $ticketId: String!) {
  deletePackageTicket(packageId: $packageId, ticketId: $ticketId)
}
    `;

/**
 * __useDeletePackageTicketMutation__
 *
 * To run a mutation, you first call `useDeletePackageTicketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePackageTicketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePackageTicketMutation, { data, loading, error }] = useDeletePackageTicketMutation({
 *   variables: {
 *      packageId: // value for 'packageId'
 *      ticketId: // value for 'ticketId'
 *   },
 * });
 */
export function useDeletePackageTicketMutation(baseOptions?: Apollo.MutationHookOptions<DeletePackageTicketMutationResult, DeletePackageTicketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePackageTicketMutationResult, DeletePackageTicketMutationVariables>(DeletePackageTicketDocument, options);
      }
export type DeletePackageTicketMutationHookResult = ReturnType<typeof useDeletePackageTicketMutation>;